/**
 * Utilitaires page contacts par programmes.
 */

export function buildFormattedTableRows (tableData, totalLabel) {
  if (!tableData || !tableData.length) {
    return {
      programNames: [],
      rows: []
    }
  }

  const programNames = tableData[0].programmes.map(p => p.nom)
  const rows = tableData.map(item => {
    const flatRow = {
      diffuseur: item.diffuseur,
      totalRow: 0,
      isTotalRow: false
    }
    item.programmes.forEach(prog => {
      flatRow[prog.nom] = prog.nbContacts || 0
      flatRow.totalRow += flatRow[prog.nom]
    })
    return flatRow
  })

  const totalFooter = {
    diffuseur: totalLabel,
    totalRow: 0,
    isTotalRow: true
  }
  programNames.forEach(name => {
    totalFooter[name] = 0
  })
  rows.forEach(row => {
    programNames.forEach(name => {
      totalFooter[name] += row[name] || 0
    })
    totalFooter.totalRow += row.totalRow
  })

  return {
    programNames,
    rows: [...rows, totalFooter]
  }
}

export function buildExcelExportRows (tableData, totalLabel) {
  const { programNames, rows } = buildFormattedTableRows(tableData, totalLabel)
  if (!rows.length) {
    return []
  }

  return rows.map(row => {
    const line = { Diffuseur: row.diffuseur }
    programNames.forEach(name => {
      line[name] = row[name] || 0
    })
    line.Total = row.totalRow
    return line
  })
}

export function canAccessContactsPrograms (user) {
  if (!user) {
    return false
  }
  const whitelist = [441233, 670607]
  if (whitelist.includes(user.id)) {
    return true
  }
  const possedeContactManager = user.possedeContactManager === true
    || user.possede_contact_manager === true
  return user.univers === 'IMMO'
    && user.metier === 'PROMOTEUR'
    && possedeContactManager
}
